import { Popover, Paper, Backdrop } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledPopoverPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 3,
  boxShadow: theme.shadows[12],
  border: '1px solid',
  borderColor: 'rgba(255, 255, 255, 0.18)',
  overflow: 'hidden',
  minWidth: '320px',
  maxWidth: '500px',
  // Glassmorphism effect
  background: 'rgba(255, 255, 255, 0.85)',
  backdropFilter: 'blur(20px) saturate(180%)',
  WebkitBackdropFilter: 'blur(20px) saturate(180%)',
  // Subtle gradient overlay for depth
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
    pointerEvents: 'none',
    zIndex: 0,
  },
  position: 'relative',
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
}))

const RosterPopover = ({ 
  open, 
  anchorEl, 
  onClose, 
  children,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' }
}) => (
  <Popover
    open={Boolean(open)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
    PaperComponent={StyledPopoverPaper}
    transitionDuration={200}
    sx={{
      zIndex: 1300,
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
      },
    }}
  >
    {children}
  </Popover>
)

export default RosterPopover 